export default __webpack_public_path__ + "icon-video53c020.png";